export default __webpack_public_path__ + "static/media/img-top-5.b0122ce3.jpg";